import { combineReducers } from 'redux';

import { appReducer } from './appReducer';
import { commentsReducer } from './commentReducer';
import { contractReducer } from './contractReducer';
import { createReviewReducer } from './createReviewReducer';
import designAuditReducer from './designAuditReducer';
import { fileContainersReducer } from './designConceptsReducer';
import designReviewReducer from './designReviewReducer';
import {
  feedReducer,
  milestonesReducer,
} from './FeedReducer';
import {
  figmaFilesReducer,
  figmaReducer,
  figmaWorkflowSteps,
  selectedFigmaFileReducer,
} from './figmaReducer';
import { historyReducer } from './historyReducer';
import { kanbanBoardReducer } from './kanbanBoardReducer';
import { notesReducer } from './notesReducer';
import { paymentReducer } from './paymentReducer';
import {
  projectReducer,
  projectStatusCountReducer,
  projectTypeMilestonesReducer,
  selectedProjectReducer,
} from './projectReducer';
import { proReducer } from './proReducer';
import { userReducer, usersReducer } from './userReducer';
import { workspaceFilesReducer } from './workspaceReducer';

const allReducers = combineReducers({
  app: appReducer,
  userStore: userReducer,
  projectStore: projectReducer,
  projectStatusCount: projectStatusCountReducer,
  allUsersStore: usersReducer,
  projectTypeMilestones: projectTypeMilestonesReducer,
  selectedProject: selectedProjectReducer,
  kanbanBoard: kanbanBoardReducer,
  figmaTokens: figmaReducer,
  figmaFiles: figmaFilesReducer,
  feedFiles: feedReducer,
  fileContainers: fileContainersReducer,
  workspaceFiles: workspaceFilesReducer,
  milestonesStore: milestonesReducer,
  paymentMethods: paymentReducer,
  selectedFigmaFile: selectedFigmaFileReducer,
  commentsStore: commentsReducer,
  contractDocument: contractReducer,
  workflowSteps: figmaWorkflowSteps,
  notesStore: notesReducer,
  designAudit: designAuditReducer,
  designReview: designReviewReducer,
  historyReducer: historyReducer,
  proStore: proReducer,
  createReview: createReviewReducer,
});

export default allReducers;
